import React, { Fragment, useCallback, useEffect, useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { ResultOperation, Column, SelfTableList, FilterState, ListFields, usePermission, useTranslation } from '@np/np_webcomponentlib'
import { API_BUSINESS } from '../../shared/consts/api'

import { DataEntityType, initEntity, columnsIdrfspecification, columnsIdrfcharacteristictype, DataEntityTypeViewModel } from './ProductProviderTypes'

import { ProductProviderForm } from './ProductProviderForm'

import { ColumnEvent, DeleteEntity, ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'

import '../../shared/entityOperations/EntityOperations.css'
import SmartSorted from './SmartSorted';
import ProviderPriorityList from './ProviderPriorityList';



const ProductProviderList = ({ listFilterFieldProps }: { listFilterFieldProps: ListFields[] }) => {

  const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('SpecificationcharacteristictypeList');

  const initialFilter: FilterState = {
    listFields: listFilterFieldProps,
    sort: null,
    searchData: '',
    take: 50,
    skip: 0,
  }

  const [idEdit, setIDEdit] = useState<string>("")

  const [forceUpdate, setForceUpdate] = useState<boolean>(false)

  const [show2, setShow2] = useState(false);
  const xtralargemodalClose = () => { setIDEdit(""); setShow2(false) };
  const xtralargemodalShow = () => setShow2(true);


  const [showSmartSorted, setShowSmartSorted] = useState(false);
  const showSmartSortedModalClose = () => { setShowSmartSorted(false) };
  const showSmartSortedModalShow = () => setShowSmartSorted(true);

  const dateAddedTitle = useTranslation('dateAdded');
  const dateUpdatedTitle = useTranslation('dateUpdated');

  const idrfSpecificationTitle = useTranslation('idrfSpecification');
  const idrfCharacteristicTypeTitle = useTranslation('idrfCharacteristicType');
  const isMandatoryTitle = useTranslation('isMandatory');


  const memoizedColumnsSpecificationcharacteristictype = useCallback(() => {
    const columnsSpecificationcharacteristictype: Column[] = [

      {
        title: '',
        listFields: null,
        type: 'custom',
        custom: (data: DataEntityType) => (

          <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
        ),
        key: 1,
        withFilter: null,
        class: "eventColumn"
      },

      {
        title: '',
        listFields: null,
        type: 'custom',
        custom: (data: DataEntityType) => (

          <ColumnEvent idUnique={data.idUnique} event={handleEdit} title='fe fe-edit eventIcom'></ColumnEvent>
        ),
        key: 2,
        withFilter: null,
        class: "eventColumn"
      },





      // {
      //   title: 'Номенклатура',
      //   listFields: {
      //     fieldName: 'idrfSpecification',
      //     comparison: 'equalsStrong',
      //     listValue: [''],
      //   },
      //   key: 6,
      //   type: 'custom',
      //   custom: (data: DataEntityTypeViewModel) => <>{data.idrfNomenclature}</>,

      //   withFilter: 'choose',

      //   filterChooseProps: {
      //     getDisplayDescription: (selectedData: any) => {
      //       return selectedData ? selectedData.name : ''
      //     },
      //     apiUrl: `${API_PRODUCT}/nomenclature/list`,
      //     columns: columnsIdrfspecification,
      //     children: 'Поиск...',
      //   },
      // },

      {
        title: 'Провайдер',
        listFields: {
          fieldName: 'idrfCatalogCategory',
          comparison: 'equalsStrong',
          listVal: [''],
        },
        key: 7,
        type: 'custom',
        custom: (data: DataEntityTypeViewModel) => <>{data.provider.name}</>,

        withFilter: 'choose',

        filterChooseProps: {
          getDisplayDescription: (selectedData: any) => {
            return selectedData ? selectedData.name : ''
          },
          apiUrl: `${API_BUSINESS}/business/list`,
          columns: columnsIdrfcharacteristictype,
          children: 'Поиск...',
        },
      },

      {
        title: 'Мерчант',
        listFields: {
          fieldName: 'idrfCatalogCategory',
          comparison: 'equalsStrong',
          listVal: [''],
        },
        key: 7,
        type: 'custom',
        custom: (data: DataEntityTypeViewModel) => <>{data.product.name}</>,

        withFilter: 'choose',

        filterChooseProps: {
          getDisplayDescription: (selectedData: any) => {
            return selectedData ? selectedData.name : ''
          },
          apiUrl: `${API_BUSINESS}/business/list`,
          columns: columnsIdrfcharacteristictype,
          children: 'Поиск...',
        },
      },


    ]
    if (debugMode) {
      columnsSpecificationcharacteristictype.push(
        {
          title: dateAddedTitle,
          listFields: {
            fieldName: 'dateAdded',
            comparison: 'containsStrong',
            listVal: [''],
          },
          type: 'date-time',
          key: 100,
          withFilter: 'onlySorted',
          class: "dateTtimeColumn"
        })
      columnsSpecificationcharacteristictype.push(
        {
          title: dateUpdatedTitle,
          listFields: {
            fieldName: 'dateUpdated',
            comparison: 'containsStrong',
            listVal: [''],
          },
          type: 'date-time',
          key: 101,
          withFilter: 'onlySorted',
          class: "dateTtimeColumn"
        })
    }



    if (debugMode || canRemove) {
      columnsSpecificationcharacteristictype.push(
        {
          title: '',
          listFields: null,
          type: 'custom',
          custom: (data: DataEntityType) => (

            <DeleteEntity idUnique={data.idUnique} apiPath={`${API_BUSINESS}/rgproductprovider`} onResult={onResultRemove}></DeleteEntity>
          ),
          key: 102,
          withFilter: null,
          class: "eventColumn"
        })
    }
    return columnsSpecificationcharacteristictype
  }, [idrfSpecificationTitle, idrfCharacteristicTypeTitle, isMandatoryTitle, dateAddedTitle, dateUpdatedTitle, debugMode, canRemove])


  const handleEdit = (idUnigue: string) => {
    setIDEdit(idUnigue)
  }

  const onResultRemove = (result: ResultOperation) => {
    if (result.status === "success") {

      setForceUpdate(true)

      console.log("forceUpdate:", forceUpdate)
    }
  }

  useEffect(() => {
    if (forceUpdate) {
      setForceUpdate(false)
    }
  }, [forceUpdate])


  useEffect(() => {
    if (idEdit !== "") {
      xtralargemodalShow()
    }
  }, [idEdit])

  const getTitleModal = () => {
    if (idEdit === "")
      return "Создание"
    else
      return "Редактирование"
  }





  return (
    <Fragment>

      {canCreate &&
        <Button variant="primary" onClick={xtralargemodalShow}><i className='fa fa-plus'></i>
        </Button>
      }

<Button variant="primary" onClick={showSmartSortedModalShow} title="Smart Sorted"><i className='fa fa-magic'></i>
</Button>


      <Modal size="xl" show={show2} onHide={xtralargemodalClose}>
        <ModalHeader>
          <ModalTitle as="h5"></ModalTitle>
          <span className="d-flex ms-auto" onClick={xtralargemodalClose}><i className='fe fe-x ms-auto' ></i></span>
        </ModalHeader>
        <ModalBody>
          <ProductProviderForm title={getTitleModal()} idInit={''} handleClose={xtralargemodalClose} initEntityProps={listFilterFieldProps.length > 0 ? { ...initEntity, idrfBusinessAsProduct: listFilterFieldProps[0].listVal[0] } : initEntity}></ProductProviderForm>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={xtralargemodalClose}>
            Закрыть
          </Button>
        </ModalFooter>
      </Modal>


      <Modal size="xl" show={showSmartSorted} onHide={showSmartSortedModalClose}>
        <ModalHeader>
          <ModalTitle as="h5"></ModalTitle>
          <span className="d-flex ms-auto" onClick={showSmartSortedModalClose}><i className='fe fe-x ms-auto' ></i></span>
        </ModalHeader>
        <ModalBody>
          <SmartSorted idBusiness={listFilterFieldProps[0].listVal[0] }></SmartSorted>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={showSmartSortedModalClose}>
            Закрыть
          </Button>
        </ModalFooter>
      </Modal>

      {/* Drag-and-drop список для мерчанта/провайдера */}
      {!show2 && listFilterFieldProps.length > 0 && (
        <ProviderPriorityList
          idBusiness={listFilterFieldProps[0].listVal[0]}
          filterFieldName={listFilterFieldProps[0].fieldName}
          canRemove={canRemove}
          forceUpdate={forceUpdate}
          onForceUpdateDone={() => setForceUpdate(false)}
        />
      )}

      {/* Таблица для общего списка (без фильтра по мерчанту) */}
      {!show2 && listFilterFieldProps.length == 0 && <SelfTableList apiUrl={`${API_BUSINESS}rgproductprovider/list`} columns={memoizedColumnsSpecificationcharacteristictype()} classProp='table' theadClassProp='table' forceUpdate={forceUpdate} />}
    </Fragment>
  )
}


export default ProductProviderList